if (!customElements.get('sticky-atc')) {

class StickyATC extends HTMLElement {

  constructor() {
    super({
      name: 'Sticky ATC',
      version: '2.0.0'
    })
    this._initialized = false;
    this._abEnableListener = null;
  }

  connectedCallback() {
    if (!this._isABEnabled()) {
      this._abEnableListener = this._handleABEnable.bind(this);
      window.addEventListener('sticky-atc:enable', this._abEnableListener);
      return;
    }
    this._init();
  }

  _handleABEnable() {
    if (this._initialized || !this._isABEnabled()) return;
    if (this._abEnableListener) {
      window.removeEventListener('sticky-atc:enable', this._abEnableListener);
      this._abEnableListener = null;
    }
    this._init();
  }

  _isABEnabled() {
    return !!(window.StickyATCAB && typeof window.StickyATCAB.isEnabled === 'function' && window.StickyATCAB.isEnabled());
  }

  _init() {
    if (this._initialized) return;
    this._initialized = true;
    
    this.sectionId = this.dataset.section || this.id.replace('sticky-', '');
    this.staticSectionId = this.sectionId;
    
    this.hasScrolledPastATC = false;
    this.originalATCButton = document.querySelector(`#ProductSubmitButton-${this.sectionId}`) || document.querySelector('.section-main-product');

    if (!this.originalATCButton) return;

    this.button = this.querySelector('[data-sticky-atc-btn]');
    this.optionLabels = this.querySelectorAll('.js-sticky-option-value');
    document.documentElement.style.setProperty('--footer-offset', `${this.offsetHeight}px`);

    this.observer = new IntersectionObserver(this.handleATCButtonIntersect.bind(this), {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    this.observer.observe(this.originalATCButton);

    this.checkInitialVisibility();
    this.button.addEventListener('click', this.onClickHandler.bind(this));

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
    } else {
      this.initFallbackListener();
    }

    this.boundOnColorVariantChanged = this.onColorVariantChanged.bind(this);
    this.boundOnProductLowerUpdated = this.onProductLowerUpdated.bind(this);

    document.addEventListener('colorVariantChanged', this.boundOnColorVariantChanged);
    document.addEventListener('productLowerUpdated', this.boundOnProductLowerUpdated);
  }

  disconnectedCallback() {
    if (this._abEnableListener) window.removeEventListener('sticky-atc:enable', this._abEnableListener);
    if (this.originalATCButton && this.observer) {
      this.observer.unobserve(this.originalATCButton);
      this.observer.disconnect();
    }
    if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
    
    document.removeEventListener('colorVariantChanged', this.boundOnColorVariantChanged);
    document.removeEventListener('productLowerUpdated', this.boundOnProductLowerUpdated);
  }

  onVariantChange(event) {
    const currentSectionId = this.getCurrentSectionId();
    if (event.data.sectionId !== this.sectionId && event.data.sectionId !== currentSectionId) return;

    this.updateLabelsFromDOM();
    setTimeout(() => this.updatePriceFromDOM(), 150);
  }

  updateOptionLabels(variant) {
    if (!variant || !variant.options) return;
    const stickyLegends = this.querySelectorAll('legend[data-optionname]');
    variant.options.forEach((optionValue, index) => {
      if (stickyLegends[index]) {
        const valueSpan = stickyLegends[index].querySelector('.js-sticky-option-value');
        if (valueSpan) valueSpan.textContent = optionValue;
      }
    });
  }

  updateLabelsFromDOM() {
    const currentId = this.getCurrentSectionId();
    const mainSection = document.getElementById(`MainProduct-${this.sectionId}`) || 
                        document.getElementById(`MainProduct-${currentId}`) ||
                        document.querySelector('.section-main-product') ||
                        document.querySelector('.product');
                        
    if (!mainSection) return;

    const mainLabelsContainer = mainSection.querySelector('.product__variant-labels-active') || mainSection;
    if (!mainLabelsContainer) return;

    const mainLegends = mainLabelsContainer.querySelectorAll('legend');
    mainLegends.forEach((mainLegend) => {
      const optionName = mainLegend.getAttribute('data-optionname');
      const mainValue = mainLegend.querySelector('.js-option-value');
      
      if (!mainValue) return;
      
      if (optionName) {
        const stickyLegend = this.querySelector(`legend[data-optionname="${optionName}"]`);
        if (stickyLegend) {
          const stickyValue = stickyLegend.querySelector('.js-sticky-option-value');
          if (stickyValue) stickyValue.textContent = mainValue.textContent;
        }
      } else {
        const stickyFakeColour = this.querySelector('.js-sticky-fake-colour');
        if (stickyFakeColour) stickyFakeColour.textContent = mainValue.textContent;
      }
    });
  }

  onColorVariantChanged() {
    this.waitForDomUpdate();
  }

  onProductLowerUpdated() {
    this.waitForDomUpdate();
  }

  getCurrentSectionId() {
    const variantRadios = document.querySelector('variant-radios');
    if (variantRadios && variantRadios.dataset.section) return variantRadios.dataset.section;
    
    const mainSection = document.querySelector('.section-main-product');
    if (mainSection && mainSection.id) return mainSection.id.replace('shopify-section-', '');

    return this.sectionId;
  }

  waitForDomUpdate() {
    let attempts = 0;
    const maxAttempts = 20;
    
    if (this.updateInterval) clearInterval(this.updateInterval);

    this.updateInterval = setInterval(() => {
      attempts++;
      const variantRadios = document.querySelector('variant-radios');
      const isReady = variantRadios && variantRadios.currentVariant;
      
      if (isReady || attempts >= maxAttempts) {
        clearInterval(this.updateInterval);
        
        const newId = this.getCurrentSectionId();
        if (newId !== this.sectionId) this.sectionId = newId;

        setTimeout(() => {
          this.updateLabelsFromDOM();
          this.updatePriceFromDOM();
        }, 200);
      }
    }, 100);
  }

  updatePriceFromDOM() {
    const currentId = this.getCurrentSectionId();
    const mainPriceSource = document.getElementById(`price-${this.sectionId}`) || 
                            document.getElementById(`price-${currentId}`) ||
                            document.getElementById(`price-main-product`) ||
                            document.querySelector('.product__price-wrapper');

    const stickyPriceContainer = document.getElementById(`price-${this.staticSectionId}-support`) || 
                                 document.getElementById(`price-${this.sectionId}-support`) ||
                                 this.querySelector('.sticky-atc__price-container');

    if (mainPriceSource && stickyPriceContainer) {
      stickyPriceContainer.innerHTML = mainPriceSource.innerHTML;
      stickyPriceContainer.classList.remove('visibility-hidden');
      stickyPriceContainer.style.display = '';

      const badge = stickyPriceContainer.querySelector('.price__badge-sale');
      if (badge) badge.style.display = 'none';
    }
  }

  initFallbackListener() {
    const mainSection = document.querySelector('.section-main-product');
    if (mainSection) {
      mainSection.addEventListener('change', (e) => {
        if (e.target.matches('input[name*="option"], select[name*="option"]')) {
          this.updateLabelsFromDOM();
        }
      });
    }
  }

  handleATCButtonIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.hideStickyATC();
      } else {
        if (!this.hasScrolledPastATC) {
          const rect = this.originalATCButton.getBoundingClientRect();
          if (rect.bottom < 0) {
            this.hasScrolledPastATC = true;
            this.showStickyATC();
          }
        } else {
          this.showStickyATC();
        }
      }
    })
  }

  showStickyATC() {
    this.style.transform = "translateY(0)";
  }

  hideStickyATC() {
    this.style.transform = "translateY(calc(100% + var(--layout-space-24)))";
  }

  checkInitialVisibility() {
    if (!this.originalATCButton) return;
    this.hideStickyATC();
    this.hasScrolledPastATC = false;
  }

  onClickHandler(event) {
    event.preventDefault();
    const currentId = this.getCurrentSectionId();
    var mainAtc = document.querySelector(`#ProductSubmitButton-${this.sectionId}`) || 
                  document.querySelector(`#ProductSubmitButton-${currentId}`);
    
    if (!mainAtc) {
       mainAtc = document.querySelector('product-form .product-form__submit') || 
                 document.querySelector('.product-form__buttons .button--add-to-cart');
    }

    if(mainAtc) mainAtc.click();
  }

}

customElements.define('sticky-atc', StickyATC);

}
